module.exports = __webpack_public_path__ + "img/5.e75fdc1b.webp";